import { execute, generateClientSyncId } from "../../apiCommandsExecutor";
import {
    AccountsGetMeRequest,
    AccountsGetMeResponse,
    AuthCheckAuthRequest,
    AuthCheckAuthResponse,
    AuthSigninRequest,
    AuthSigninResponse, AuthSignupRequest, AuthSignupResponse
} from "./requestsResponses";
import { AuthApiMethods } from "./methods";


export const signIn = async (phoneNumber: string) => {
    const res = await execute<AuthSigninRequest, AuthSigninResponse>(AuthApiMethods.signIn, {
        phoneNumber, clientSyncId: generateClientSyncId()
    });
    return res.data;
};

export const enterCode = async (params: { phoneNumber: string, authCode: string }) => {
    const res = await execute<AuthCheckAuthRequest, AuthCheckAuthResponse>(AuthApiMethods.checkAuth, {
        ...params
    });
    return res.data;
};
export const signUp = async (phoneNumber: string) => {
    const res = await execute<AuthSignupRequest, AuthSignupResponse>(AuthApiMethods.signUp, {
        phoneNumber: phoneNumber,
        clientSyncId: generateClientSyncId()
    });
    return res.data;
};



export const getCurrent = async () => {
    return await execute<AccountsGetMeRequest, AccountsGetMeResponse>(AuthApiMethods.getMe, {
        clientSyncId: generateClientSyncId()
    });
};


export const recoverPassword = async (login: string, password: string) => {
    /*const res = await execute<AuthSigninRequest, AuthSigninResponse>(ApiMethods.AuthSignin, {
        password, clientSyncId: generateClientSyncId()
    })*/
};
